import { addLocaleData } from 'react-intl';
import { setTranslations } from '@99designs/globalnav/locale-data';
import Bugsnag, { LOG_LEVEL } from 'common/utils/Bugsnag';

export function loadIntlDataForLocale(locale) {
    return new Promise((resolve) => {
        const loadData = (...args) => {
            addLocaleData.apply(null, args);
            resolve();
        };

        switch (locale.slice(0,2)) {
            case 'de': return require(['react-intl/locale-data/de'], loadData);
            case 'en': return require(['react-intl/locale-data/en'], loadData);
            case 'es': return require(['react-intl/locale-data/es'], loadData);
            case 'nl': return require(['react-intl/locale-data/nl'], loadData);
            case 'pt': return require(['react-intl/locale-data/pt'], loadData);
            case 'ja': return require(['react-intl/locale-data/ja'], loadData);
            case 'fr': return require(['react-intl/locale-data/fr'], loadData);
            case 'it': return require(['react-intl/locale-data/it'], loadData);
            default:
                Bugsnag.notify(
                    'InvalidLocaleError',
                    'Missing data for locale:',
                    locale,
                    LOG_LEVEL.ERROR
                );
                resolve();
        }
    });
}

export function loadGlobalNavIntlDataForLocale(locale) {
    return new Promise((resolve) => {
        const loadData = (data) => {
            setTranslations(data.default);
            resolve();
        };

        switch (locale.slice(0,2)) {
            case 'de': return require(['@99designs/globalnav/locale-data/de'], loadData);
            case 'en': return require(['@99designs/globalnav/locale-data/en'], loadData);
            case 'es': return require(['@99designs/globalnav/locale-data/es'], loadData);
            case 'fr': return require(['@99designs/globalnav/locale-data/fr'], loadData);
            case 'it': return require(['@99designs/globalnav/locale-data/it'], loadData);
            case 'ja': return require(['@99designs/globalnav/locale-data/ja'], loadData);
            case 'nl': return require(['@99designs/globalnav/locale-data/nl'], loadData);
            case 'pt': return require(['@99designs/globalnav/locale-data/pt'], loadData);
            default:
                Bugsnag.notify(
                    'InvalidLocaleError',
                    'Missing GlobalNav data for locale:',
                    locale,
                    LOG_LEVEL.ERROR
                );
                resolve();
        }
    });
}



// WEBPACK FOOTER //
// ./js/common/utils/intl.js